import style from "./Banner.module.css";
import { Button } from "@mui/material";
import { JSX } from "react";

export interface BannerItems {
  id: string;
  icon: JSX.Element;
  title: string;
  subTitle: string;
}

export default function Banner({
  img,
  title,
  subTitle,
  cta,
  ctaClick,
  roundOff,
  revert,
  MaskedImgComponent,
}: {
  img: string;
  title: string;
  subTitle: string;
  cta: string;
  ctaClick: () => void;
  roundOff: boolean;
  revert: boolean;
  MaskedImgComponent: React.ComponentType<any>;
}) {
  return (
    <div
      className={`${style.bannerBoxMainContainer} ${revert && style.revert}`}
    >
      <div
        className={style.bannerBox}
        style={{ display: "flex", justifyContent: "center" }}
      >
        {MaskedImgComponent ? (
            <MaskedImgComponent style={{margin: "auto", width: "fit-content"}}/>
        ) : (
          <img
            className={`${style.bannerImg} ${roundOff && style.roundOff}`}
            src={img}
            alt="coopia giovane sorridente"
          />
        )}
      </div>
      <div className={style.bannerBox}>
        <h1 className={style.bannerTitle}>{title}</h1>
        <p className={style.bannerSubTitle}>{subTitle}</p>
        <Button
          style={{ marginTop: "1em" }}
          color={"primary"}
          variant={"contained"}
          onClick={() => ctaClick()}
        >
          {cta}
        </Button>
      </div>
    </div>
  );
}
